import { render, staticRenderFns } from "./SubmissionTestPackageItem.vue?vue&type=template&id=ee582498"
import script from "./SubmissionTestPackageItem.vue?vue&type=script&lang=js"
export * from "./SubmissionTestPackageItem.vue?vue&type=script&lang=js"
import style0 from "./SubmissionTestPackageItem.vue?vue&type=style&index=0&id=ee582498&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports